import { useDispatch, useSelector } from 'react-redux'
// import { fetchLogs } from '../../actions/LogsAction'
import './Logs.css'

import React, { useEffect, useState } from 'react'
import Header from '../../components/Header/Header'
import MetricsModal from './MetricsModal'
import { universalSearchApi } from '../../api/SearchRequest'
import { getItem } from '../../api/ItemManipulation'
import { getItemDetail } from '../../api/ItemRequest'
import { getUser } from '../../api/UserRequest'
import { loadModal } from '../../actions/ModalAction'
import { getDatumWithStampDetails, getDatum_One } from '../../api/DatumManipulation'
import './Dashboard.css';
import { 
    fetchActiveUsers,
    fetchLogs,
    fetchActiveGuests,
    fetchActionCounts,
    fetchTotals,
    fetchPageViews,
    fetchSessionMetrics,
    fetchAvgTimeOnPage,
    fetchBounceData,
    fetchTrafficSources,
    fetchConversionMetrics,
    searchLogsApi
} from '../../api/LogsRequest'
import { LuRefreshCcw } from 'react-icons/lu'

const Logs = () => {
    const [activeTab, setActiveTab] = useState("Users");
    const [timescale, setTimescale] = useState("week");
    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const { logs } = useSelector((state) => state.logsReducer);
    const [selectedLog, setSelectedLog] = useState(null);
    const [searchResults, setSearchResults] = useState(null);

    // Metrics state
    const [activeUsers, setActiveUsers] = useState([]);
    const [activeGuests, setActiveGuests] = useState([]);
    const [actionCounts, setActionCounts] = useState([]);
    const [totals, setTotals] = useState(null);
    const [pageViews, setPageViews] = useState([]);
    const [sessionMetrics, setSessionMetrics] = useState(null);
    const [avgTimeOnPage, setAvgTimeOnPage] = useState([]);
    const [bounceData, setBounceData] = useState([]);
    const [trafficSources, setTrafficSources] = useState([]);
    const [conversionMetrics, setConversionMetrics] = useState(null);
    const [loading, setLoading] = useState(false);
    const [lastRefreshed, setLastRefreshed] = useState(new Date());
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [searchResults2, setSearchResults2] = useState(null);
    const [viewAsQuery, setViewAsQuery] = useState("");
    const [viewAsUser, setViewAsUser] = useState(null);
    const [metricsTarget, setMetricsTarget] = useState(null);
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);

    const dispatch = useDispatch();
    const [logPage, setLogPage] = useState(0);
    const [hasMoreLogs, setHasMoreLogs] = useState(true);
    const [logsList, setLogsList] = useState([]);
    const [isLoadingMoreLogs, setIsLoadingMoreLogs] = useState(false);

    const [userPage, setUserPage] = useState(0);
    const [hasMoreUsers, setHasMoreUsers] = useState(true);
    const [isLoadingMoreUsers, setIsLoadingMoreUsers] = useState(false);
    const [guestPage, setGuestPage] = useState(0);
    const [hasMoreGuests, setHasMoreGuests] = useState(true);
    const [isLoadingMoreGuests, setIsLoadingMoreGuests] = useState(false);

    const loadLogs = async (page = 0, append = false) => {
        try {
            const res = await fetchLogs(page, 100);
            const { logs, hasMore } = res.data;
            setLogsList(prev => append ? [...prev, ...logs] : logs);
            setHasMoreLogs(hasMore);
            setLogPage(page);
        } catch (error) {
            console.error('Error loading logs:', error);
        }
    };

    const loadMoreLogs = async () => {
        if (!hasMoreLogs || isLoadingMoreLogs) return;
        setIsLoadingMoreLogs(true);
        await loadLogs(logPage + 1, true);
        setIsLoadingMoreLogs(false);
    };

    const loadMoreUsers = async () => {
        if (!hasMoreUsers || isLoadingMoreUsers) return;
        setIsLoadingMoreUsers(true);
        try {
            const res = await fetchActiveUsers(15, userPage + 1);
            setActiveUsers(prev => [...prev, ...res.data.users]);
            setHasMoreUsers(res.data.hasMore);
            setUserPage(prev => prev + 1);
        } catch (error) {
            console.error('Error loading more users:', error);
        }
        setIsLoadingMoreUsers(false);
    };

    const loadMoreGuests = async () => {
        if (!hasMoreGuests || isLoadingMoreGuests) return;
        setIsLoadingMoreGuests(true);
        try {
            const res = await fetchActiveGuests(15, guestPage + 1);
            setActiveGuests(prev => [...prev, ...res.data.guests]);
            setHasMoreGuests(res.data.hasMore);
            setGuestPage(prev => prev + 1);
        } catch (error) {
            console.error('Error loading more guests:', error);
        }
        setIsLoadingMoreGuests(false);
    };

    useEffect(() => {
        loadLogs(0);
        loadAllMetrics();
    }, []);

    useEffect(() => {
        loadAllMetrics();
    }, [timescale]);

    useEffect(() => {
        return () => {
            dispatch({ type: 'CLEAR_VIEW_AS_USER'});
        }
    }, []);

    const loadAllMetrics = async (start = startDate, end = endDate) => {
        setLoading(true);
        try {
            const params = {
                ...(start && { startDate: start }),
                ...(end && { endDate: end })
            };

            const [
                usersRes, guestsRes, actionsRes, totalsRes,
                pageViewsRes, sessionRes, avgTimeRes,
                bounceRes, sourcesRes, conversionRes
            ] = await Promise.all([
                fetchActiveUsers(15, 0),
                fetchActiveGuests(15, 0),
                fetchActionCounts(timescale),
                fetchTotals(),
                fetchPageViews(params),
                fetchSessionMetrics(params),
                fetchAvgTimeOnPage(params),
                fetchBounceData(params),
                fetchTrafficSources(params),
                fetchConversionMetrics()
            ]);

            setActiveUsers(usersRes.data.users || []);
            setHasMoreUsers(usersRes.data.hasMore || false);
            setUserPage(0);

            setActiveGuests(guestsRes.data.guests || []);
            setHasMoreGuests(guestsRes.data.hasMore || false);
            setGuestPage(0);

            setActionCounts(actionsRes.data);
            setTotals(totalsRes.data);
            setPageViews(pageViewsRes.data);
            setSessionMetrics(sessionRes.data);
            setAvgTimeOnPage(avgTimeRes.data);
            setBounceData(bounceRes.data);
            setTrafficSources(sourcesRes.data);
            setConversionMetrics(conversionRes.data);
        } catch (error) {
            console.error("Error loading metrics:", error);
        }
        setLoading(false);
    };


    // Auto-refresh every 30 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            dispatch(fetchLogs());
            loadAllMetrics();
            setLastRefreshed(new Date());
            setRefresh(prev => !prev);
        }, 30000);

        return () => clearInterval(interval);
    }, [timescale, startDate, endDate]);

    const handleSearch = async () => {
        if (!searchQuery.trim()) {
            setSearchResults(null);
            setSearchResults2(null);
            dispatch(fetchLogs());
            return;
        }
        try {
            const { data } = await universalSearchApi(searchQuery.trim());
            setSearchResults2(data);
            setShowSearchDropdown(true);

            const logRes = await searchLogsApi(searchQuery.trim());
            setSearchResults(logRes.data);
        } catch (error) {
            console.error("Search error:", error);
        }
    };

    const getTriggers = (user, _id) => {
        const stampIndex = user.stamps.findIndex((stamp) => stamp.datumId === _id);
        if (stampIndex > -1) {
            const trig = user.stamps[stampIndex].triggers
            return trig
        } else {
            return [];
        }

    }

    const handleSelectResult = async (result, type) => {
        setShowSearchDropdown(false);
        if (viewAsUser) {
            dispatch({ type: 'SET_VIEW_AS_USER', payload: viewAsUser });
            const logDetails = {
                activity: "admin_view_item",
                category: "interaction",
                userId: viewAsUser._id,
                data: {
                    userId: viewAsUser._id,
                    username: viewAsUser.username,
                },
                response: null,
                sessionId: localStorage.getItem('sessionId'),
                status: null
            }
            let value;
            dispatch({type: "MODAL_ITEM_VIEW_START"});
            if (type === 'item') {
                value = await getItem(result._id, viewAsUser._id, JSON.stringify(logDetails))
                const data = {
                    modalType: type,
                    data: value.data
                }
                dispatch(loadModal(data, logDetails))
            }
            if (type === 'datum') {
                let datumData;
                let triggers;
                if (viewAsUser.userType === 0) {
                    const res = await getDatumWithStampDetails(result._id, viewAsUser._id);
                    datumData = res.data;
                } else {
                    const res = await getDatum_One(result._id);
                    datumData = res.data;
                    triggers = await getTriggers(viewAsUser, result._id);

                    const logDetails = { 
                        activity: "admin_load_user",
                        category: 'interaction',
                        userId: viewAsUser._id,
                        sessionId: localStorage.getItem('sessionId'),
                        data: {
                            userId: viewAsUser._id,
                            username: viewAsUser.username
                        }
                    };
                    const encodedLogDetails = encodeURIComponent(JSON.stringify(logDetails));

                    const authorDetails = await getUser(datumData.userId, encodedLogDetails);
                    datumData.authorId = authorDetails.data._id;
                    datumData.authorName = authorDetails.data.username;
                    datumData.authorImage = authorDetails.data.userImage;

                    for (let r = 0; r < datumData.references.length; r++) {
                        const refId = datumData.references.shift();
                        const referenceDetails = await getItemDetail(refId);
                        datumData.references.push(referenceDetails.data);
                    }
                }
                value =
                    {
                        modalType: 'datum',
                        data: datumData,
                        stamped: datumData.stamps?.includes(viewAsUser._id) || false,
                        stamps: datumData.stamps?.length || 0,
                        viewed: datumData.views?.includes(viewAsUser._id) || false,
                        views: datumData.views?.length || 0,
                        datumType: datumData.datumType,
                        triggers: triggers,
                        setTriggersProp:  () => {},
                        setStamped: () => {},
                        setStamps: () => {},
                        setViewed: () => {},
                        setViews: () => {},
                        setMainContent: () => {}
                    }
                dispatch(loadModal(value, logDetails));
            }
            if (type === "user") {
                value = await getUser(result._id, 'nolog');
                const data = {
                    modalType: type,
                    data: value.data
                }
                dispatch(loadModal(data, logDetails))
            }
        } else {
            setMetricsTarget({ result, type });
        }
    };

    const handleViewAsSearch = async () => {
        if (!viewAsQuery.trim()) {
            setViewAsUser(null);
            return;
        }
        try {
            const { data } = await universalSearchApi(viewAsQuery.trim());
            if (data.users.length > 0) {
                setViewAsUser(data.users[0]);
            }
        } catch (error) {
            console.error('View As search error:', error);
        }
    };

    const handleManualRefresh = async () => {
        setIsRefreshing(true);
        setRefresh(true)
        setUserPage(0)
        setGuestPage(0)
        setLogPage(0)
        await loadLogs(0);
        await loadAllMetrics();
        setLastRefreshed(new Date());
        setIsRefreshing(false);
        setTimeout(() => setRefresh(false), 1000);
    };

    const handleDateFilter = () => {
        loadAllMetrics(startDate, endDate);
    };

    const getActionCount = (activityName, statusFilter = null) => {
        return actionCounts
            .filter(a =>
                a._id.activity === activityName &&
                (statusFilter ? a._id.status === statusFilter : true)
            )
            .reduce((sum, a) => sum + a.count, 0);
    };

    const getMaxActionCount = () => {
        const counts = [
            getActionCount('signup_attempt'),
            getActionCount('forgot_password_submitted'),
            getActionCount('login_attempt'),
            getActionCount('edit_profile'),
            getActionCount('item_created'),
            getActionCount('datum_created'),
            getActionCount('item_view_opened'),
            getActionCount('datum_view_opened'),
            getActionCount('user_view_opened'),
            getActionCount('item_referenced'),
            getActionCount('datum_markedViewed'),
            getActionCount('datum_stamped'),
            getActionCount('item_triggered'),
            getActionCount('item_adopted'),
            getActionCount('datum_feedback'),
            getActionCount('worksheet_saved'),
            getActionCount('worksheet_create_run'),,
        ];
        return Math.max(...counts, 1);
    };

    const getBarHeight = (count) => {
        const max = getMaxActionCount();
        return `${Math.max((count / max) * 100, 3)}%`;
    };

    const formatDuration = (seconds) => {
        if (!seconds && seconds !== 0) return 'N/A';
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
    };

    const formatDurationMs = (ms) => {
        if (!ms) return 'N/A';
        return formatDuration(ms / 1000);
    };

    const formatLogDate = (timestamp) => {
        const date = new Date(timestamp);
        return `${date.toDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    };

    const formatShortDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    // User type label
    const userTypeLabel = (type) => {
        if (type === 0) return 'General';
        if (type === 1) return 'Author';
        if (type === 2) return 'Group';
        return 'Unknown';
    };

    return (
        <div className='HeaderGrid'>
            <div className='home-header-container'>
                <Header location="home" />
            </div>
            <div className="dashboard-wrapper">

                {/* LEFT PANEL — Event Stream */}
                <aside className="left-panel"
                    onScroll={(e) => {
                        const { scrollTop, scrollHeight, clientHeight } = e.target;
                        if (scrollHeight - scrollTop - clientHeight < 50) {
                            loadMoreLogs();
                        }
                    }}
                
                >
                    <div className="log-container">
                        <div className="log-header-title">
                            Event Stream 
                            <span onClick={handleManualRefresh}
                                title="Refresh"
                                style={{
                                    cursor: 'pointer',
                                    fontSize: 10,
                                    color: '#c2410c',
                                    display: 'inline-block',
                                    transition: 'transform 0.5s ease',
                                    marginLeft: 8,
                                }}
                                >
                                <LuRefreshCcw className={isRefreshing ? 'refresh-spin' : ''} />
                            </span>
                            <div style={{ fontSize: 9, color: '#9ca3af', marginTop: 2 }}>
                                Last updated: {lastRefreshed.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                            </div>
                        </div>
                        {logsList.map((entry, index) => {
                            let statusClass = "";
                            if (entry.statusCode === 1 || entry.status === 'failure') statusClass = "status-1";
                            if (entry.statusCode === 2) statusClass = "status-2";
                            return (
                                <div
                                    key={entry._id || index}
                                    className={`compact-log-item ${statusClass}`}
                                    onClick={() => setSelectedLog(entry)}
                                >
                                    <div className="log-user">
                                        <span className="clickable-username">
                                            {entry.data?.username || entry.data?.ip_address || "@system"}
                                        </span>
                                        <span className="log-activity"> — {entry.activity}</span>
                                    </div>
                                    <div className="timestamp">{formatShortDate(entry.createdAt)}</div>
                                </div>
                            );
                        })}
                        {isLoadingMoreLogs && (
                            <div style={{ padding: 8, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
                                Loading more...
                            </div>
                        )}
                        {!hasMoreLogs && logsList.length > 0 && (
                            <div style={{ padding: 8, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
                                — End of logs —
                            </div>
                        )}
                    </div>
                </aside>

                {/* CENTER PANEL */}
                <main className="center-panel">
                    <div className="top-controls-grid">

                        {/* Search + View As */}
                        <div className="stack">
                            <div style={{ position: 'relative' }}>
                                <textarea
                                    className="search-box"
                                    placeholder={"Search by username, userId,\ndatumId, or itemId"}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && handleSearch()}
                                />
                                <button
                                    className="view-as-btn purple-outline"
                                    onClick={handleSearch}
                                >
                                    Search
                                </button>

                                {/* Search Results Dropdown */}
                                {showSearchDropdown && searchResults2 && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        background: '#fff',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: 6,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        zIndex: 100,
                                        maxHeight: 300,
                                        overflowY: 'auto'
                                    }}>
                                        {/* Users */}
                                        {searchResults2.users.length > 0 && (
                                            <>
                                                <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', padding: '6px 10px 2px', textTransform: 'uppercase' }}>Users</div>
                                                {searchResults2.users.map((u, i) => (
                                                    <div
                                                        key={i}
                                                        style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}
                                                        className="search-result-row"
                                                        onClick={() => handleSelectResult(u, 'user')}
                                                    >
                                                        <strong>@{u.username}</strong>
                                                        <span style={{ color: '#9ca3af', marginLeft: 6, fontSize: 10 }}>{u._id}</span>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {/* Items */}
                                        {searchResults2.items.length > 0 && (
                                            <>
                                                <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', padding: '6px 10px 2px', textTransform: 'uppercase' }}>Items</div>
                                                {searchResults2.items.map((item, i) => (
                                                    <div
                                                        key={i}
                                                        style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}
                                                        className="search-result-row"
                                                        onClick={() => handleSelectResult(item, 'item')}
                                                    >
                                                        <strong>{item.itemName}</strong>
                                                        <span style={{ color: '#9ca3af', marginLeft: 6, fontSize: 10 }}>{item._id}</span>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {/* Datums */}
                                        {searchResults2.datums.length > 0 && (
                                            <>
                                                <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', padding: '6px 10px 2px', textTransform: 'uppercase' }}>Datums</div>
                                                {searchResults2.datums.map((d, i) => (
                                                    <div
                                                        key={i}
                                                        style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}
                                                        className="search-result-row"
                                                        onClick={() => handleSelectResult(d, 'datum')}
                                                    >
                                                        <span style={{ fontSize: 11 }}>
                                                            {d.datumText ? d.datumText.slice(0, 60) + '...' : '(Relation datum)'}
                                                        </span>
                                                        <span style={{ color: '#9ca3af', marginLeft: 6, fontSize: 10 }}>{d._id}</span>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {searchResults2.users.length === 0 && searchResults2.items.length === 0 && searchResults2.datums.length === 0 && (
                                            <div style={{ padding: 12, fontSize: 12, color: '#9ca3af' }}>No results found</div>
                                        )}
                                        <div
                                            style={{ padding: '6px 10px', fontSize: 11, color: '#9ca3af', cursor: 'pointer', textAlign: 'right' }}
                                            onClick={() => setShowSearchDropdown(false)}
                                        >
                                            ✕ Close
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* View As */}
                            <div style={{ display: 'flex', gap: 4 }}>
                                <input
                                    style={{ flex: 1, fontSize: 11, padding: '4px 6px', border: '1px solid #d1d5db', borderRadius: 4 }}
                                    placeholder="View As (username or userId)"
                                    value={viewAsQuery}
                                    onChange={(e) => setViewAsQuery(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleViewAsSearch()}
                                />
                                <button className="purple-outline" style={{ fontSize: 11, padding: '2px 8px' }} onClick={handleViewAsSearch}>
                                    Set
                                </button>
                                {viewAsUser && (
                                    <button
                                        style={{ fontSize: 10, color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}
                                        onClick={() => { setViewAsUser(null); setViewAsQuery(''); dispatch({ type: 'CLEAR_VIEW_AS_USER'}); }}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                            {viewAsUser && (
                                <div style={{ fontSize: 11, color: '#16a34a', padding: '2px 0' }}>
                                    👁 Viewing as: <strong>@{viewAsUser.username}</strong>
                                </div>
                            )}
                        </div>

                        {/* Total Stats */}
                        <div className="total-stats-box purple-outline">
                            {totals ? (
                                <div style={{ width: '100%', padding: '0 12px', fontSize: 13 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span>Users</span>
                                        <strong>{totals.users.total}</strong>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, fontSize: 11, color: '#6b7280', marginBottom: 4 }}>
                                        {totals.users.byType.map(t => (
                                            <span key={t._id}>{userTypeLabel(t._id)}: {t.count}</span>
                                        ))}
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                        <span>Items</span>
                                        <strong>{totals.items.total}</strong>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Data</span>
                                        <strong>{totals.data.total}</strong>
                                    </div>
                                </div>
                            ) : (
                                <span style={{ fontSize: 13, color: '#9ca3af' }}>Loading totals...</span>
                            )}
                        </div>

                        {/* Timescale + Date Range */}
                        <div className="stack">
                            <select
                                className="timescale-dropdown purple-outline"
                                value={timescale}
                                onChange={(e) => setTimescale(e.target.value)}
                                style={{ cursor: 'pointer' }}
                            >
                                <option value="today">Today</option>
                                <option value="week">This Week</option>
                                <option value="month">This Month</option>
                            </select>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                <input
                                    type="date"
                                    className="purple-outline"
                                    style={{ height: 28, fontSize: 11, padding: '0 4px', width: 148 }}
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <input
                                    type="date"
                                    className="purple-outline"
                                    style={{ height: 28, fontSize: 11, padding: '0 4px', width: 148 }}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                <button
                                    className="historical-btn purple-outline"
                                    onClick={handleDateFilter}
                                    style={{ fontSize: 11 }}
                                >
                                    Apply Date Range
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ACTIONS CHART */}
                    <div className="chart-area blue-outline">
                        {/* Row 1 — Auth & Profile actions */}
                        <div className="chart-bars">
                            <Bar
                                val={`${getActionCount('signup_success')}/${getActionCount('signup_attempt')}/${getActionCount('signup_failure')}`}
                                height={getBarHeight(getActionCount('signup_attempt'))}
                                label="Signups" color="green"
                            />
                            <Bar
                                val={`${getActionCount('forgot_password_submitted')}/${getActionCount('forgot_password_failure')}/${getActionCount('forgot_password_success')}`}
                                height={getBarHeight(getActionCount('forgot_password_submitted'))}
                                label="Forgot PW" color="gray"
                            />
                            <Bar
                                val={`${getActionCount('login_success')}/${getActionCount('login_attempt')}/${getActionCount('login_failure')}`}
                                height={getBarHeight(getActionCount('login_attempt'))}
                                label="Login" color="green"
                            />
                            <Bar
                                val={getActionCount('edit_profile')}
                                height={getBarHeight(getActionCount('edit_profile'))}
                                label="Profile Edit" color="gray"
                            />
                            <Bar
                                val={getActionCount('item_created')}
                                height={getBarHeight(getActionCount('item_created'))}
                                label="Item Created" color="blue"
                            />
                            <Bar
                                val={getActionCount('datum_created')}
                                height={getBarHeight(getActionCount('datum_created'))}
                                label="Datum Created" color="blue"
                            />
                            <Bar
                                val={getActionCount('item_view_opened')}
                                height={getBarHeight(getActionCount('item_view_opened'))}
                                label="Item View" color="blue"
                            />
                            <Bar
                                val={getActionCount('datum_view_opened')}
                                height={getBarHeight(getActionCount('datum_view_opened'))}
                                label="Datum View" color="blue"
                            />
                            <Bar
                                val={getActionCount('user_view_opened')}
                                height={getBarHeight(getActionCount('user_view_opened'))}
                                label="User View" color="blue"
                            />
                        </div>

                        <div className="chart-row-divider" />

                        {/* Row 2 — Content & Worksheet actions */}
                        <div className="chart-bars">
                            <Bar
                                val={getActionCount('item_referenced')}
                                height={getBarHeight(getActionCount('item_referenced'))}
                                label="Referenced" color="blue"
                            />
                            <Bar
                                val={getActionCount('datum_markedViewed')}
                                height={getBarHeight(getActionCount('datum_markedViewed'))}
                                label="Datum Viewed" color="gray"
                            />
                            <Bar
                                val={getActionCount('datum_stamped')}
                                height={getBarHeight(getActionCount('datum_stamped'))}
                                label="Stamped" color="purple"
                            />
                            <Bar
                                val={getActionCount('item_triggered')}
                                height={getBarHeight(getActionCount('item_triggered'))}
                                label="Triggered" color="blue"
                            />
                            <Bar
                                val={getActionCount('item_adopted')}
                                height={getBarHeight(getActionCount('item_adopted'))}
                                label="Adopted" color="blue"
                            />
                            <Bar
                                val={getActionCount('datum_feedback')}
                                height={getBarHeight(getActionCount('datum_feedback'))}
                                label="Feedback" color="blue"
                            />
                            <Bar
                                val={getActionCount('worksheet_saved')}
                                height={getBarHeight(getActionCount('worksheet_saved'))}
                                label="Sheet Saved" color="purple"
                            />
                            <Bar
                                val={getActionCount('worksheet_create_run')}
                                height={getBarHeight(getActionCount('worksheet_create_run'))}
                                label="Create Run" color="purple"
                            />
                        </div>

                        <div className="chart-label">
                            Actions — {timescale === 'today' ? 'Today' : timescale === 'week' ? 'This Week' : 'This Month'}
                            {loading && <span style={{ fontSize: 11, color: '#9ca3af', marginLeft: 8 }}>Refreshing...</span>}
                        </div>
                    </div>

                    {/* BOTTOM DATA MATRIX */}
                    <div className="bottom-data-matrix">

                        {/* PAGE VIEWS TABLE */}
                        <div className="cell table-cell blue-outline">
                            <div className="cell-header">
                                <span>Page Views</span>
                                <span className="tiny">Unique / Total</span>
                            </div>
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Page</th>
                                        <th>Views</th>
                                        <th>Avg Time</th>
                                        <th>Unique</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageViews.length > 0 ? pageViews.map(p => {
                                        const avgTime = avgTimeOnPage.find(a => a._id === p._id);
                                        return (
                                            <tr key={p._id}>
                                                <td>{p.page || p._id}</td>
                                                <td>{p.views}</td>
                                                <td>{avgTime ? formatDuration(Math.floor(avgTime.avgDuration)) : '—'}</td>
                                                <td>{p.uniqueUsers}</td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr><td colSpan={4} style={{ color: '#9ca3af', fontSize: 11 }}>No page view data</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* SESSIONS */}
                        <div className="cell blue-outline">
                            <div className="cell-header">
                                <span>Sessions</span>
                            </div>
                            <div className="cell-body">
                                {sessionMetrics ? (
                                    <>
                                        <p style={{ marginBottom: 6 }}>
                                            Total Sessions: <strong>{sessionMetrics.totalSessions}</strong>
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Avg Length: <strong>{formatDurationMs(sessionMetrics.avgDurationMs)}</strong>
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Unique Users: <strong>{sessionMetrics.uniqueUsers}</strong>
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Avg per User: <strong>
                                                {sessionMetrics.uniqueUsers > 0
                                                    ? (sessionMetrics.totalSessions / sessionMetrics.uniqueUsers).toFixed(1)
                                                    : '—'}
                                            </strong>
                                        </p>
                                        <p>
                                            Multiple Sessions: <strong>{sessionMetrics.multipleSessionsPercent}%</strong>
                                        </p>
                                    </>
                                ) : <span style={{ fontSize: 12, color: '#9ca3af' }}>Loading...</span>}
                            </div>
                        </div>

                        {/* KEY CONVERSION METRICS */}
                        <div className="cell survey-cell blue-outline">
                            <div className="cell-header">Key Conversions</div>
                            <div className="cell-body">
                                {conversionMetrics ? (
                                    <>
                                        <p style={{ marginBottom: 6 }}>
                                            Visitors → Signup: <strong className="green-text">{conversionMetrics.signupConversionRate}%</strong>
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Users viewed content: <strong>{conversionMetrics.viewEngagementRate}%</strong>
                                        </p>
                                        <p style={{ marginBottom: 6 }}>
                                            Multiple sessions: <strong>{conversionMetrics.multipleSessionsRate}%</strong>
                                        </p>
                                        <p style={{ marginBottom: 6, fontSize: 11, color: '#6b7280' }}>
                                            {conversionMetrics.totalVisitors} total visitors
                                        </p>
                                        <p style={{ fontSize: 11, color: '#6b7280' }}>
                                            {conversionMetrics.usersWithActivity} users engaged
                                        </p>
                                    </>
                                ) : <span style={{ fontSize: 12, color: '#9ca3af' }}>Loading...</span>}
                            </div>
                        </div>

                        <div className="cell blue-outline" style={{ overflowY: 'scroll', maxHeight: '55vh' }}>
                            <div className="cell-header">Survey Feedback</div>
                            <SurveyAdmin refresh={refresh} />
                        </div>

                        <div className="cell blue-outline" style={{ overflowY: 'scroll', maxHeight: '55vh' }}>
                            <BusinessSuggestions refresh={refresh} />
                        </div>

                        <div className="cell-stack">
                            <div className="metric-box flex-2 blue-outline" style={{ flexDirection: 'column', alignItems: 'flex-start', overflowY: 'scroll' }}>
                                <div className="cell-header" style={{ width: '100%' }}>Sources</div>
                                {trafficSources.length > 0 ? trafficSources.slice(0, 4).map((s, i) => (
                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: 11, marginBottom: 3 }}>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '60%' }}>
                                            {s.source ? new URL(s.source).hostname : 'Direct'}
                                        </span>
                                        <span>{s.count} ({s.percentage}%)</span>
                                    </div>
                                )) : (
                                    <span style={{ fontSize: 11, color: '#9ca3af' }}>No referrer data</span>
                                )}
                            </div>
                            <div className="metric-box flex-2 blue-outline" style={{ flexDirection: 'column', alignItems: 'flex-start', overflowY: 'scroll' }}>
                                <div className="cell-header" style={{ width: '100%' }}>Bounces by Page</div>
                                {bounceData.length > 0 ? bounceData.slice(0, 4).map((b, i) => (
                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: 11, marginBottom: 3 }}>
                                        <span>{b._id || 'Unknown'}</span>
                                        <span>{b.bounceCount}</span>
                                    </div>
                                )) : (
                                    <span style={{ fontSize: 11, color: '#9ca3af' }}>No bounce data</span>
                                )}
                            </div>
                        </div>
                    </div>
                </main>

                {/* RIGHT PANEL */}
                <aside className="right-panel"
                    onScroll={(e) => {
                        const { scrollTop, scrollHeight, clientHeight } = e.target;
                        if (scrollHeight - scrollTop - clientHeight < 50) {
                            if (activeTab === 'Users') loadMoreUsers();
                            if (activeTab === 'Guests') loadMoreGuests();
                        }
                    }}>
                    <div className="tab-header">
                        <div className={`tab ${activeTab === 'Users' ? 'active' : ''}`} onClick={() => setActiveTab('Users')}>
                            Users
                        </div>
                        <div className={`tab ${activeTab === 'Guests' ? 'active' : ''}`} onClick={() => setActiveTab('Guests')}>
                            Guests
                        </div>
                    </div>
                    <div className="sort-bar">Most Recent Activity</div>
                    <div className="right-list-content" style={{ overflowY: 'auto', height: 'calc(100% - 80px)' }}
                        onScroll={(e) => {
                            const { scrollTop, scrollHeight, clientHeight } = e.target;
                            if (scrollHeight - scrollTop - clientHeight < 50) {
                                if (activeTab === 'Users') loadMoreUsers();
                                if (activeTab === 'Guests') loadMoreGuests();
                            }
                        }}
                    >
                        {activeTab === 'Users' ? (
                            activeUsers.length > 0 ? activeUsers.map((u, i) => (
                                <div
                                    key={i}
                                    className="orange-row"
                                    style={{ display: 'flex', alignItems: 'center', padding: '4px 8px', gap: 8, cursor: 'pointer' }}
                                    onClick={() => setMetricsTarget({ result: u.user, type: "user" })}
                                >
                                    {u.user ? (
                                        <>
                                            <img
                                                src={process.env.REACT_APP_PUBLIC_FOLDER + u.user.userImage}
                                                style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                            <div style={{ flex: 1, overflow: 'hidden' }}>
                                                <div style={{ fontSize: 11, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {u.user.username}
                                                </div>
                                                <div style={{ fontSize: 10, color: '#9ca3af' }}>
                                                    {u.activityCount} events · {formatShortDate(u.lastActivity)}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ fontSize: 11, color: '#9ca3af' }}>{u._id}</div>
                                    )}
                                </div>
                            )) : (
                                <div style={{ padding: 12, fontSize: 12, color: '#9ca3af' }}>No active users</div>
                            )
                        ) : (
                            activeGuests.length > 0 ? activeGuests.map((g, i) => (
                                <div
                                    key={i}
                                    className="orange-row"
                                    style={{ padding: '4px 8px' }}
                                >
                                    <div style={{ fontSize: 11, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {g._id}
                                    </div>
                                    <div style={{ fontSize: 10, color: '#9ca3af' }}>
                                        {g.activityCount} events · {formatShortDate(g.lastActivity)}
                                    </div>
                                </div>
                            )) : (
                                <div style={{ padding: 12, fontSize: 12, color: '#9ca3af' }}>No guest sessions</div>
                            )
                        )}
                        {isLoadingMoreUsers || isLoadingMoreGuests && (
                            <div style={{ padding: 8, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
                                Loading more...
                            </div>
                        )}
                        {activeTab === 'Users' ? (
                            !hasMoreUsers && activeUsers.length > 0 && (
                                <div style={{ padding: 8, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
                                    — End of logs —
                                </div>
                            )
                        ): (
                            !hasMoreGuests && activeGuests.length > 0 && (
                                <div style={{ padding: 8, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
                                    — End of logs —
                                </div>
                            ) 
                        )}                        
                    </div>

                </aside>
            </div>

            {/* LOG DETAIL MODAL */}
            {selectedLog && (
                <div className="modal-overlay" onClick={() => setSelectedLog(null)}>
                    <div className="details-modal" onClick={e => e.stopPropagation()}>
                        <h3>Event Details</h3>
                        <hr />
                        <div className="modal-content">
                            <p><strong>Activity:</strong> {selectedLog.activity}</p>
                            <p><strong>Category:</strong> {selectedLog.category || 'N/A'}</p>
                            <p><strong>Status:</strong> {selectedLog.status || 'N/A'}</p>
                            <p><strong>User:</strong> {selectedLog.data?.username || selectedLog.userId || 'N/A'}</p>
                            <p><strong>Page:</strong> {selectedLog.page || 'N/A'}</p>
                            <p><strong>Session:</strong> {selectedLog?.sessionId || selectedLog?.data?.sessionId || 'N/A'}</p>
                            <p><strong>Duration:</strong> {selectedLog.duration != null ? `${selectedLog.duration}s` : 'N/A'}</p>
                            <p><strong>Referrer:</strong> {selectedLog.referrer || 'N/A'}</p>
                            <p><strong>Timestamp:</strong> {formatLogDate(selectedLog.createdAt)}</p>
                            {selectedLog.itemId && <p><strong>Item ID:</strong> {selectedLog.itemId}</p>}
                            {selectedLog.datumId && <p><strong>Datum ID:</strong> {selectedLog.datumId}</p>}
                            <div className="raw-data-section">
                                <strong>Raw Data:</strong>
                                <pre>{JSON.stringify(selectedLog.data, null, 2)}</pre>
                            </div>
                        </div>
                        <button className="close-modal-btn" onClick={() => setSelectedLog(null)}>Close</button>
                    </div>
                </div>
            )}
            {metricsTarget && (
                <MetricsModal
                    result={metricsTarget.result}
                    resultType={metricsTarget.type}
                    onClose={() => setMetricsTarget(null)}
                />
            )}
        </div>
    );
};

const Bar = ({ val, height, label, color }) => (
    <div className="bar-wrapper">
        <span className="bar-val">{val}</span>
        <div className={`bar-fill ${color}`} style={{ height }}></div>
        <span className="bar-label">{label}</span>
    </div>
);


const SurveyAdmin = ({ refresh }) => {
    const [surveys, setSurveys] = useState([]);
    const [newSurvey, setNewSurvey] = useState({ title: '', template: 1, question: '', options: ['', ''] });
    const [showCreate, setShowCreate] = useState(false);
    const [results, setResults] = useState({});

    useEffect(() => {
        fetchSurveys();
    }, []);

    useEffect(() => {
        fetchSurveys();
    }, [refresh]);

    const fetchSurveys = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/all`, { credentials: 'include' });
        const data = await res.json();
        setSurveys(data);
    };

    const handleToggle = async (surveyId) => {
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/toggle/${surveyId}`, {
            method: 'PATCH', credentials: 'include'
        });
        fetchSurveys();
    };

    const handleCreate = async () => {
        const options = newSurvey.options
            .filter(o => o.trim())
            .map((text, i) => ({ 
                text, 
                color: ['#4a6fa5', '#f97316', '#16a34a', '#8b5cf6', '#ef4444'][i % 5] 
            }));
    
        if (newSurvey._id) {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/edit/${newSurvey._id}`, {
                method: 'PATCH',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: newSurvey.title, question: newSurvey.question, options })
            });
        } else {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/create`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...newSurvey, options })
            });
        }
    
        setShowCreate(false);
        setNewSurvey({ title: '', template: 1, question: '', options: ['', ''] });
        fetchSurveys();
    };

    const viewResults = async (surveyId) => {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/results/${surveyId}`, { credentials: 'include' });
        const data = await res.json();
        setResults(prev => ({ ...prev, [surveyId]: data }));
    };
    const handleDelete = async (surveyId) => {
        if (!window.confirm('Delete this survey and all its responses?')) return;
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/${surveyId}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        fetchSurveys();
    };
    
    const handleEdit = (survey) => {
        setNewSurvey({
            _id: survey._id,
            title: survey.title,
            template: survey.template,
            question: survey.question,
            options: survey.options.map(o => o.text)
        });
        setShowCreate(true);
    };

    return (
        <div style={{ fontSize: 12 }}>
            <button className="button" style={{ fontSize: 11, marginBottom: 8 }} onClick={() => setShowCreate(!showCreate)}>
                + New Survey
            </button>

            {showCreate && (
                <div style={{ border: '1px solid #ddd', padding: 8, marginBottom: 8, borderRadius: 4 }}>
                    <input placeholder="Title" value={newSurvey.title} onChange={e => setNewSurvey({ ...newSurvey, title: e.target.value })} style={{ width: '100%', marginBottom: 4, fontSize: 11, padding: 4 }} />
                    <select value={newSurvey.template} onChange={e => setNewSurvey({ ...newSurvey, template: parseInt(e.target.value) })} style={{ marginBottom: 4, fontSize: 11 }}>
                        <option value={1}>Template 1 — Single Choice (Pie)</option>
                        <option value={2}>Template 2 — Multi Choice (Bar)</option>
                    </select>
                    <textarea placeholder="Question" value={newSurvey.question} onChange={e => setNewSurvey({ ...newSurvey, question: e.target.value })} style={{ width: '100%', marginBottom: 4, fontSize: 11, padding: 4 }} />
                    {newSurvey.options.map((opt, i) => (
                        <input key={i} placeholder={`Option ${i + 1}`} value={opt}
                            onChange={e => {
                                const opts = [...newSurvey.options];
                                opts[i] = e.target.value;
                                setNewSurvey({ ...newSurvey, options: opts });
                            }}
                            style={{ width: '100%', marginBottom: 4, fontSize: 11, padding: 4 }}
                        />
                    ))}
                    <button style={{ fontSize: 10, marginRight: 4 }} onClick={() => setNewSurvey({ ...newSurvey, options: [...newSurvey.options, ''] })}>+ Option</button>
                    <button className="button" style={{ fontSize: 11 }} onClick={handleCreate}>Save Survey</button>
                </div>
            )}

            {surveys.map(s => (
                <div key={s._id} style={{ borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
                    <div style={{ fontWeight: 600 }}>{s.title}</div>
                    <div style={{ color: '#6b7280', fontSize: 11 }}>Template {s.template} · {s.isActive ? '🟢 Active' : '⚫ Hidden'}</div>
                    <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
                        <button style={{ fontSize: 10 }} onClick={() => handleToggle(s._id)}>
                            {s.isActive ? 'Hide' : 'Show'}
                        </button>
                        <button style={{ fontSize: 10 }} onClick={() => viewResults(s._id)}>
                            Results
                        </button>
                        <button style={{ fontSize: 10 }} onClick={() => handleEdit(s)}>
                            Edit
                        </button>
                        <button 
                            style={{ fontSize: 10, color: '#ef4444' }} 
                            onClick={() => handleDelete(s._id)}
                        >
                            Delete
                        </button>
                    </div>
                    {results[s._id] && (
                        <div style={{ marginTop: 4, fontSize: 11 }}>
                            <strong>{results[s._id].total} responses</strong>
                            {results[s._id].counts.map((c, i) => (
                                <div key={i}>{c.option}: {c.count}</div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const BusinessSuggestions = ({ refresh }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSuggestions();
    }, []);

    useEffect(() => {
        fetchSuggestions();
    }, [refresh]);

    const fetchSuggestions = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/survey/suggestions`, { credentials: 'include' });
            const data = await res.json();
            setSuggestions(data);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        }
        setLoading(false);
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div style={{ fontSize: 12, height: '100%', overflowY: 'auto' }}>
            <div className="cell-header">
                <span>Business Suggestions</span>
                <span className="tiny">{suggestions.length} total</span>
            </div>
            {loading ? (
                <span style={{ fontSize: 11, color: '#9ca3af' }}>Loading...</span>
            ) : suggestions.length > 0 ? (
                suggestions.map((s, i) => (
                    <div key={i} style={{ borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
                        <div style={{ fontWeight: 600 }}>{s.businessName}</div>
                        {s.phoneNumber && (
                            <div style={{ fontSize: 11, color: '#6b7280' }}>📞 {s.phoneNumber}</div>
                        )}
                        {s.email && (
                            <div style={{ fontSize: 11, color: '#6b7280' }}>✉️ {s.email}</div>
                        )}
                        {s.contactPerson && (
                            <div style={{ fontSize: 11, color: '#6b7280' }}>👤 {s.contactPerson}</div>
                        )}
                        <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>
                            {formatDate(s.createdAt)}
                        </div>
                    </div>
                ))
            ) : (
                <span style={{ fontSize: 11, color: '#9ca3af' }}>No suggestions yet</span>
            )}
        </div>
    );
};


export default Logs